//import library
import "bootstrap-daterangepicker";

let dateRangePicker = (selector) => {
  const pluginOptions = {
    autoApply: false,
    locale: {
      format: "DD.MM.YYYY",
      separator: " - ",
      applyLabel: "Onayla",
      cancelLabel: "Vazgeç",
      fromLabel: "Tarih Aralığı",
      toLabel: "-",
      customRangeLabel: "Tarih Seç",
      weekLabel: "H",
      daysOfWeek: ["Pa", "Pts", "Sa", "Çar", "Per", "Cu", "Cts"],
      monthNames: [
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara",
      ],
      firstDay: 1,
    },
    alwaysShowCalendars: false,
    opens: "left",
  };

  let elements = document.querySelectorAll(selector);

  elements.forEach((item) => {
    $(item).daterangepicker(pluginOptions);
  });
};

let dateTimePicker = (selector) => {
  const pluginOptions = {
    autoApply: false,
    singleDatePicker: true,
    timePicker: true,
    timePicker24Hour: true,
    firstDay: 1,
    drops: "auto",
    opens: "left",
    timePickerIncrement: 15,
    locale: {
      format: "DD.MM.YYYY HH:mm",
      separator: " - ",
      applyLabel: "Onayla",
      cancelLabel: "Vazgeç",
      fromLabel: "Tarih Aralığı",
      toLabel: "-",
      customRangeLabel: "Tarih Seç",
      weekLabel: "H",
      daysOfWeek: ["Pa", "Pts", "Sa", "Çar", "Per", "Cu", "Cts"],
      monthNames: [
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara",
      ],
      firstDay: 1,
    },
  };

  let elements = document.querySelectorAll(selector);

  elements.forEach((item) => {
    $(item).daterangepicker(pluginOptions, function (start) {
      let targetEl = document.getElementById(item.dataset.target);
      targetEl.value = start.format("YYYY-MM-DDTHH:mm:ss.000Z");
    });
  });
};

let datePicker = (selector) => {
  const pluginOptions = {
    autoApply: true,
    singleDatePicker: true,
    linkedCalendars: false,
    firstDay: 1,
    drops: "auto",
    opens: "left",
    locale: {
      format: "DD.MM.YYYY",
      separator: " - ",
      applyLabel: "Onayla",
      cancelLabel: "Vazgeç",
      fromLabel: "Tarih Aralığı",
      toLabel: "-",
      customRangeLabel: "Tarih Seç",
      weekLabel: "H",
      daysOfWeek: ["Pa", "Pts", "Sa", "Çar", "Per", "Cu", "Cts"],
      monthNames: [
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara",
      ],
      firstDay: 1,
    },
  };

  let elements = document.querySelectorAll(selector);

  elements.forEach((item) => {
    $(item).daterangepicker(pluginOptions, function (start) {
      let targetEl = document.getElementById(item.dataset.target);
      targetEl.value = start.format("YYYY-MM-DDTHH:mm:ss.000Z");
    });
  });
};

export { dateRangePicker, dateTimePicker, datePicker };
